// Cache utility for authenticated-cache-isolation.
//
// Contrato único: clearAuthCaches() devuelve Promise<string[]>
// que resuelve con el array de nombres de caches propios
// (prefijo "adamsched-") purgados en éxito; rechaza (throw)
// en cualquier fallo de seguridad (fail-closed).
//
// Semántica:
//   - typeof caches === 'undefined' → throw (fail-closed)
//   - caches.keys() lanza → throw
//   - caches.delete(name) === false aislado NO implica fallo
//     (otro proceso pudo haberlo borrado)
//   - tras intentar borrar, re-leer caches.keys(); si queda
//     algún cache propio de AdamSched → throw (postcondición)
//   - sin caché propio → resuelve el array de nombres purgados
const ADAMSCHED_CACHE_PREFIX = 'adamsched-';

export async function clearAuthCaches() {
  if (typeof caches === 'undefined') {
    throw new Error('CacheStorage API unavailable');
  }

  let initial;
  try {
    const keys = await caches.keys();
    initial = keys.filter((k) => k.startsWith(ADAMSCHED_CACHE_PREFIX));
  } catch (err) {
    throw new Error(`caches.keys() failed: ${err.message}`);
  }

  // Best-effort delete: una promesa que resuelve false no es fallo.
  await Promise.all(
    initial.map((k) => caches.delete(k).catch(() => false))
  );

  let remaining;
  try {
    const keys = await caches.keys();
    remaining = keys.filter((k) => k.startsWith(ADAMSCHED_CACHE_PREFIX));
  } catch (err) {
    throw new Error(`caches.keys() postcondition failed: ${err.message}`);
  }

  if (remaining.length > 0) {
    throw new Error(
      `Cache purge incomplete; remaining AdamSched caches: ${remaining.join(', ')}`
    );
  }

  return initial;
}
